/** Arabic region name for ISO 3166-1 alpha-2 (e.g. JO → الأردن) */
export function regionNameAr(code: string | undefined | null): string {
  if (!code || !/^[A-Za-z]{2}$/.test(String(code).trim())) return '';
  const upper = String(code).trim().toUpperCase();
  try {
    return new Intl.DisplayNames(['ar'], { type: 'region' }).of(upper) || upper;
  } catch {
    return upper;
  }
}

/** Region name in Arabic or English based on UI language */
export function regionDisplayName(code: string | undefined | null, language: string): string {
  if (!code || !/^[A-Za-z]{2}$/.test(String(code).trim())) return '';
  const upper = String(code).trim().toUpperCase();
  const loc = String(language || 'ar').toLowerCase().startsWith('en') ? 'en' : 'ar';
  try {
    return new Intl.DisplayNames([loc], { type: 'region' }).of(upper) || upper;
  } catch {
    return upper;
  }
}

export const OA_COUNTRY_STORAGE_KEY = 'oa_country';
